/**
 * Plain hex for `<meta name="theme-color">`, the Vite theme-bootstrap copy, API defaults,
 * and any other non-token string. Same values as `palette.bgApplicationLight` /
 * `palette.bgApplicationDark` in `./colors`.
 */
export const applicationThemeHex: { readonly light: string; readonly dark: string } = {
  light: '#FFFFFF',
  dark: '#282A3D',
};

export type ApplicationThemeHexKey = keyof typeof applicationThemeHex;
